// Step ids shared by the Ring AIR and Ring PRO buy panels and their contexts.
export type RingBuyStepId =
  | 'color-picker'
  | 'size-select'
  | 'delivery'
  | 'charger-select'
  | 'trade-in'
  | 'engraving'
  | 'clue-addon'
  | 'max'
  | 'bling-stacking'
  | 'order-overview';

// Ultrahuman MAX replaces the UHX coverage and PowerPlug steps; bling follows it.
export const RING_AIR_BUY_STEP_ORDER: RingBuyStepId[] = [
  'color-picker',
  'size-select',
  'charger-select',
  'trade-in',
  'engraving',
  'clue-addon',
  'max',
  'bling-stacking',
  'order-overview',
];
